module.exports = __webpack_public_path__ + "static/media/austronesia_lanyu_community_boat_celebrate.fbc41fff.jpg";